import React from 'react'
import './loadingSpinner.css'

class LoadingSpinner extends React.Component {
  timeout = null;
  constructor(props) {
    super(props)
    this.state = {
      hidden: props.delay ? true : false
    }
  }
  componentDidMount() {
    const {delay} = this.props
    if (delay) {
      this.timeout = window.setTimeout(() => this.setState({hidden: false}), delay)
    }
  }
  componentWillUnmount() {
    window.clearTimeout(this.timeout)
  }
  render() {
    const { className, light, noMargin } = this.props
    const {hidden} = this.state
    const classNames = ['lds-spinner']
    if (light) {
      classNames.push('lds-spinner--light')
    }
    if (className) {
      classNames.push(className)
    }
    const style = {
      height: '100%',
      width: '100%'
    }
    if (noMargin) {
      style.marginTop = 0
    }
    if (hidden) {
      return (
        <div className={classNames.join(' ')} style={style} />
      )
    }
    return (
      <div className={classNames.join(' ')} style={style}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    )
  }
}

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/core/components/loading-spinner/LoadingSpinner.js